import { stateService } from '@/services/api/state.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { stateModel } from '@/models/api/state.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const STATE_MODULE = "api/state";

// ACTIONS
export const GET_ALL_STATE = 'getAllState';
export const CREATE_STATE = 'createState';
export const GET_STATE = 'getState';
export const UPDATE_STATE = 'updateState';
export const UPDATE_STATE_STATUS = 'updateStateStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_STATE_SUCCESS = "allStateSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_STATE_SUCCESS = "getStateSuccess";

export const actions = {
    [GET_ALL_STATE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        stateService
            .getAll(filter)
            .then((result) => {
                commit(ALL_STATE_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_STATE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return stateService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_STATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_STATE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return stateService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_STATE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_STATE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return stateService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_STATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_STATE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return stateService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_STATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_STATE_SUCCESS](state, {data}) {
        let stateList = data.data || [];
        state.list.data = stateList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = stateList.map(item => stateModel(item));
        }
    },
    [GET_STATE_SUCCESS](state, data) {
        state.details = stateModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
